var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2187_42661)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.07031,
    y: 6.05469,
    width: 29.208,
    height: 29.208,
    rx: 14.604,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.07031,
    y: 6.05469,
    width: 29.208,
    height: 29.208,
    rx: 14.604,
    fill: "url(#paint0_radial_2187_42661)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.07031,
    y: 6.05469,
    width: 29.208,
    height: 29.208,
    rx: 14.604,
    fill: "url(#paint1_radial_2187_42661)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.37488,
    y: 5.35926,
    width: 30.5989,
    height: 30.5989,
    rx: 15.2994,
    stroke: "white",
    strokeWidth: 1.39086
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2187_42661)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6753 14.5312C17.2903 14.5312 14.5469 17.2747 14.5469 20.6597C14.5469 24.0447 17.2903 26.7882 20.6753 26.7882C24.0603 26.7882 26.8038 24.0447 26.8038 20.6597C26.8038 17.2747 24.0603 14.5312 20.6753 14.5312ZM20.6753 16.096C21.4016 16.096 22.0981 16.3845 22.6116 16.898C23.1251 17.4115 23.4136 18.108 23.4136 18.8342C23.4136 19.5604 23.1251 20.2569 22.6116 20.7705C22.0981 21.284 21.4016 21.5725 20.6753 21.5725C19.9491 21.5725 19.2526 21.284 18.7391 20.7705C18.2256 20.2569 17.9371 19.5604 17.9371 18.8342C17.9371 18.108 18.2256 17.4115 18.7391 16.898C19.2526 16.3845 19.9491 16.096 20.6753 16.096ZM20.6753 25.745C19.806 25.7455 18.9511 25.5229 18.1924 25.0987C17.4337 24.6744 16.7964 24.0626 16.3416 23.3218C17.7013 22.6982 19.1795 22.3753 20.6753 22.3753C22.1712 22.3753 23.6494 22.6982 25.0091 23.3218C24.5543 24.0626 23.917 24.6744 23.1583 25.0987C22.3995 25.5229 21.5446 25.7455 20.6753 25.745Z",
    fill: "#516CD3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2187_42661",
    x: 0.507115,
    y: 0.49149,
    width: 40.3373,
    height: 40.3373,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.08629
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2187_42661"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2187_42661",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2187_42661",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.778 12.1397) rotate(51.0441) scale(24.5185 24.5185)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2187_42661",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.2772 31.6117) rotate(-93.6705) scale(24.9998 27.8633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#516CD3",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#516CD3",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861815,
    stopColor: "#516CD3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2187_42661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.5177,
    height: 12.5177,
    fill: "white",
    transform: "translate(14.4141 14.3984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLogo);
export default __webpack_public_path__ + "static/media/ProfileLogo.3feadd3c4afa67fcdf61da090b6b007d.svg";
export { ForwardRef as ReactComponent };